/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateDeckInput = {
  deck_name?: string | null,
  deck_id: string,
};

export type Deck = {
  __typename: "Deck",
  pk: string,
  sk: string,
  deckGSI_pk?: string | null,
  deckGSI_sk?: string | null,
  deck_name?: string | null,
  created_date?: string | null,
  last_updated_date?: string | null,
  created_by?: string | null,
  last_updated_by?: string | null,
  locked_by?: string | null,
  locked_at?: string | null,
  lock_expiry?: string | null,
  publish_status?: PublishStatus | null,
  publish_user?: string | null,
  publish_deck_cycle?: string | null,
  has_active_system_run?: boolean | null,
  last_publish_date?: string | null,
  publish_timestamp?: string | null,
  deck_cycle?: string | null,
};

export enum PublishStatus {
  PUBLISH_STARTED = "PUBLISH_STARTED",
  PUBLISH_IN_PROGRESS = "PUBLISH_IN_PROGRESS",
  KPI_UPLOAD_COMPLETED = "KPI_UPLOAD_COMPLETED",
  KPI_UPLOAD_FAILED = "KPI_UPLOAD_FAILED",
  KPI_CALCULATION_COMPLETED = "KPI_CALCULATION_COMPLETED",
  KPI_CALCULATION_FAILED = "KPI_CALCULATION_FAILED",
  DECK_UPDATE_COMPLETED = "DECK_UPDATE_COMPLETED",
  DECK_UPDATE_FAILED = "DECK_UPDATE_FAILED",
}


export type CreateTOCEntryInput = {
  deck_id: string,
  toc_id: string,
  page_id?: string | null,
  page_no?: string | null,
  toc_page_name?: string | null,
  page_name?: string | null,
  is_visible?: boolean | null,
  is_active: boolean,
  group_name?: string | null,
  serial_no?: number | null,
};

export type TOCEntry = {
  __typename: "TOCEntry",
  pk: string,
  sk: string,
  toc_id: string,
  page_id?: string | null,
  page_no?: string | null,
  toc_page_name?: string | null,
  page_name?: string | null,
  is_visible?: boolean | null,
  is_active?: boolean | null,
  group_name?: string | null,
  serial_no?: number | null,
  created_date?: string | null,
  last_updated_date?: string | null,
  schedule_type?: ScheduleType | null,
};

export enum ScheduleType {
  APPROVED = "APPROVED",
  MODIFIED = "MODIFIED",
}


export type CreateScenarioManagementEntryInput = {
  deck_id: string,
  scenario_id: string,
  deck_cycle?: string | null,
  month?: string | null,
  page_name?: string | null,
  page_no?: string | null,
  sno?: string | null,
  is_external_page?: boolean | null,
  page_grain?: string | null,
  schedule_type?: ScheduleType | null,
  is_supplemental?: boolean | null,
  is_blankpage?: boolean | null,
  toc_sno?: string | null,
  toc_page_no?: string | null,
};

export type ScenarioManagementEntry = {
  __typename: "ScenarioManagementEntry",
  pk: string,
  sk: string,
  scenario_id: string,
  deck_cycle?: string | null,
  month?: string | null,
  page_name?: string | null,
  page_no?: string | null,
  sno?: string | null,
  is_external_page?: boolean | null,
  page_grain?: string | null,
  schedule_type: ScheduleType,
  last_updated_date?: string | null,
  is_supplemental?: boolean | null,
  is_blankpage?: boolean | null,
  toc_sno?: string | null,
  toc_page_no?: string | null,
};

export type CreatePageInput = {
  page_id: string,
  page_name?: string | null,
  deck_id?: string | null,
  page_grain?: string | null,
  page_no?: number | null,
  previous_page_id?: string | null,
  next_page_id?: string | null,
  page_drivers?: KPIDriversInput | null,
  page_type?: string | null,
  denominator_label?: DenominatorLabelValues | null,
};

export type KPIDriversInput = {
  account_hierarchy?: string | null,
  account?: string | null,
  location_hierarchy?: string | null,
  location?: string | null,
  project_hierarchy?: string | null,
  project?: string | null,
  company_hierarchy?: string | null,
  company?: string | null,
  product_hierarchy?: string | null,
  product?: string | null,
  revgp_hierarchy?: string | null,
  revgp?: string | null,
  datasource_hierarchy?: string | null,
  datasource?: string | null,
  channel_hierarchy?: string | null,
  channel?: string | null,
  costcenter_hierarchy?: string | null,
  costcenter?: string | null,
  costtype?: string | null,
  costpool?: string | null,
};

export enum DenominatorLabelValues {
  GROSS_MARGIN = "GROSS_MARGIN",
  REVENUE = "REVENUE",
  OPERATING_MARGIN = "OPERATING_MARGIN",
}


export type Page = {
  __typename: "Page",
  pk: string,
  sk: string,
  pageGSI_pk?: string | null,
  pageGSI_sk?: string | null,
  page_name?: string | null,
  deck_id?: string | null,
  page_grain?: string | null,
  page_no?: number | null,
  page_drivers?: KPIDrivers | null,
  previous_page_id?: string | null,
  next_page_id?: string | null,
  page_type?: string | null,
  denominator_label?: DenominatorLabelValues | null,
  locked_by?: string | null,
  locked_at?: string | null,
  lock_expiry?: string | null,
};

export type KPIDrivers = {
  __typename: "KPIDrivers",
  account_hierarchy?: string | null,
  account?: string | null,
  location_hierarchy?: string | null,
  location?: string | null,
  project_hierarchy?: string | null,
  project?: string | null,
  company_hierarchy?: string | null,
  company?: string | null,
  product_hierarchy?: string | null,
  product?: string | null,
  revgp_hierarchy?: string | null,
  revgp?: string | null,
  datasource_hierarchy?: string | null,
  datasource?: string | null,
  channel_hierarchy?: string | null,
  channel?: string | null,
  costcenter_hierarchy?: string | null,
  costcenter?: string | null,
  costtype?: string | null,
  costpool?: string | null,
};

export type CreateDecklineInput = {
  page_id: string,
  deckline_id: string,
  page_name?: string | null,
  kpi_id?: string | null,
  kpi_name?: string | null,
  kpi_formula?: string | null,
  serial_no?: string | null,
  is_code_or_description?: CodeOrDescription | null,
  is_format_bold?: boolean | null,
  is_format_italics?: boolean | null,
  is_format_underline?: boolean | null,
  format_text_color?: string | null,
  format_cell_color?: string | null,
  format_cell_default?: CellFormat | null,
  blankline_type?: BlanklineType | null,
  is_format_borderline?: boolean | null,
  footnotes?: Array< number | null > | null,
  subtotal_formula?: string | null,
  is_calculated_kpi?: CalculatedKPIValues | null,
  subtotal_parent?: string | null,
  deckline_drivers?: KPIDriversInput | null,
  is_exception?: boolean | null,
  page_section?: string | null,
  column_template?: string | null,
  adjcalcflag?: boolean | null,
  exceptioncalculatedkpiflag?: boolean | null,
  bordertopflag?: boolean | null,
  borderrightflag?: boolean | null,
  borderbottomflag?: boolean | null,
  borderleftflag?: boolean | null,
  borderweightflag?: BorderWeight | null,
  textunderlineflag?: boolean | null,
  denominator_kpi_id_for_pct?: string | null,
  denominator_kpi_id_drivers?: KPIDriversInput | null,
  denominator_is_calculated_kpi?: CalculatedKPIValues | null,
  denominator_kpi_formula?: string | null,
  root_kpi_id?: string | null,
  kpi_variant_id?: string | null,
  display_name?: string | null,
  denominator_kpi_variant_id?: string | null,
  kpi_name_indent_level?: number | null,
  fxinclflag?: string | null,
  calcdivisionflag?: string | null,
  bps_override_flag?: string | null,
  comments?: Array< CommentInput | null > | null,
};

export enum CodeOrDescription {
  CODE = "CODE",
  DESCRIPTION = "DESCRIPTION",
  BOTH = "BOTH",
}


export enum CellFormat {
  NONE = "NONE",
  NUMBER = "NUMBER",
  PERCENT = "PERCENT",
  PERCENT_1 = "PERCENT_1",
  PERCENT_2 = "PERCENT_2",
  BPS = "BPS",
}


export enum BlanklineType {
  BLANKLINE = "BLANKLINE",
  BLANKLINE_ADJUSTMENT = "BLANKLINE_ADJUSTMENT",
  BLANKLINE_CALCULATED_ADJUSTMENT = "BLANKLINE_CALCULATED_ADJUSTMENT",
}


export enum CalculatedKPIValues {
  I = "I",
  Y = "Y",
  N = "N",
  NA = "NA",
}


export enum BorderWeight {
  N = "N",
  THIN = "THIN",
  THICK = "THICK",
}


export type CommentInput = {
  commentId: string,
  user: string,
  commentDesc: string,
  timestamp: string,
};

export type Deckline = {
  __typename: "Deckline",
  pk: string,
  sk: string,
  page_name?: string | null,
  kpi_id?: string | null,
  kpi_name?: string | null,
  kpi_formula?: string | null,
  serial_no?: string | null,
  is_code_or_description?: CodeOrDescription | null,
  is_format_bold?: boolean | null,
  is_format_italics?: boolean | null,
  is_format_underline?: boolean | null,
  format_text_color?: string | null,
  format_cell_color?: string | null,
  format_cell_default?: CellFormat | null,
  blankline_type?: BlanklineType | null,
  is_format_borderline?: boolean | null,
  footnotes?: Array< number | null > | null,
  subtotal_formula?: string | null,
  subtotal_parent?: string | null,
  is_calculated_kpi?: CalculatedKPIValues | null,
  deckline_drivers?: KPIDrivers | null,
  is_exception?: boolean | null,
  page_section?: string | null,
  column_template?: string | null,
  adjcalcflag?: boolean | null,
  exceptioncalculatedkpiflag?: boolean | null,
  bordertopflag?: boolean | null,
  borderrightflag?: boolean | null,
  borderbottomflag?: boolean | null,
  borderleftflag?: boolean | null,
  borderweightflag?: BorderWeight | null,
  textunderlineflag?: boolean | null,
  denominator_kpi_id_for_pct?: string | null,
  denominator_kpi_id_drivers?: KPIDrivers | null,
  denominator_is_calculated_kpi?: CalculatedKPIValues | null,
  denominator_kpi_formula?: string | null,
  root_kpi_id?: string | null,
  kpi_variant_id?: string | null,
  display_name?: string | null,
  denominator_kpi_variant_id?: string | null,
  kpi_name_indent_level?: number | null,
  fxinclflag?: string | null,
  calcdivisionflag?: string | null,
  bps_override_flag?: string | null,
  comments?:  Array<Comment | null > | null,
};

export type Comment = {
  __typename: "Comment",
  commentId: string,
  user: string,
  commentDesc: string,
  timestamp: string,
};

export type CreateDeckColumnInput = {
  page_id: string,
  deck_id?: string | null,
  deckcolumn_id: string,
  column_template?: string | null,
  page_section?: string | null,
  column_no?: number | null,
  column_title?: string | null,
  column_name?: string | null,
  no_of_columns?: number | null,
  column_description?: string | null,
  scenario_display_name?: string | null,
  scenario_period?: string | null,
  block_id?: number | null,
  footnotes?: Array< number | null > | null,
  comparison_scenario?: string | null,
  comparison_scenario_period?: string | null,
  fx_scenario?: string | null,
  fx_scenario_period?: string | null,
  denominator_scenario?: string | null,
  denominator_scenario_period?: string | null,
  block_header?: string | null,
  non_material_flag?: string | null,
  denominator_kpi_exception_flag?: string | null,
  column_mapping_group?: string | null,
  report_header?: string | null,
  time_grain?: string | null,
  deck_cycle?: string | null,
};

export type DeckColumn = {
  __typename: "DeckColumn",
  pk: string,
  sk: string,
  deckColumnGSI_pk?: string | null,
  deckColumnGSI_sk?: string | null,
  deck_id?: string | null,
  column_template?: string | null,
  page_section?: string | null,
  column_no?: number | null,
  column_title?: string | null,
  column_name?: string | null,
  no_of_columns?: number | null,
  column_description?: string | null,
  scenario_display_name?: string | null,
  scenario_period?: string | null,
  block_id?: number | null,
  comparison_scenario?: string | null,
  comparison_scenario_period?: string | null,
  fx_scenario?: string | null,
  fx_scenario_period?: string | null,
  denominator_scenario?: string | null,
  denominator_scenario_period?: string | null,
  block_header?: string | null,
  non_material_flag?: string | null,
  denominator_kpi_exception_flag?: string | null,
  last_updated_date?: string | null,
  column_mapping_group?: string | null,
  report_header?: string | null,
  time_grain?: string | null,
  deck_cycle?: string | null,
};

export type CreateKPIInput = {
  kpi_id: string,
  deck_id: string,
  is_calculated_kpi?: CalculatedKPIValues | null,
  kpi_formula?: string | null,
  kpi_map?: KPIDriversInput | null,
};

export type KPI = {
  __typename: "KPI",
  pk: string,
  sk: string,
  is_calculated_kpi?: CalculatedKPIValues | null,
  kpi_formula?: string | null,
  kpi_map?: KPIDrivers | null,
  last_updated_date?: string | null,
};

export type CreateFootnoteInput = {
  footnote_id: string,
  page_id: string,
  footnote_no?: string | null,
  footnote_description?: string | null,
};

export type Footnote = {
  __typename: "Footnote",
  pk: string,
  sk: string,
  footnote_no?: string | null,
  footnote_description?: string | null,
};

export type SaveDeckInput = {
  deck_id: string,
  deck_name: string,
  save_timestamp?: string | null,
  change_set: ChangesInput,
};

export type ChangesInput = {
  toc?: TOCOperationsInput | null,
  deckline?: DecklineOperationsInput | null,
  deckcolumn?: DeckColumnOperationsInput | null,
  footnote?: FootnoteOperationsInput | null,
  kpi?: KPIOperationsInput | null,
  page?: PageOperationsInput | null,
  scenario?: ScenarioManagementOperationsInput | null,
  audit?: AuditHistoryOperationsInput | null,
};

export type TOCOperationsInput = {
  create?: Array< TOCItemsInput | null > | null,
  update?: Array< TOCItemsInput | null > | null,
  delete?: Array< TOCDeleteItemsInput | null > | null,
};

export type TOCItemsInput = {
  toc_id: string,
  page_id?: string | null,
  page_no?: string | null,
  toc_page_name?: string | null,
  page_name?: string | null,
  is_visible?: boolean | null,
  is_active: boolean,
  group_name?: string | null,
  serial_no?: number | null,
  schedule_type?: ScheduleType | null,
};

export type TOCDeleteItemsInput = {
  toc_id: string,
};

export type DecklineOperationsInput = {
  create?: Array< DecklineItemsInput | null > | null,
  update?: Array< DecklineItemsInput | null > | null,
  delete?: Array< DecklineDeleteItemsInput | null > | null,
};

export type DecklineItemsInput = {
  page_id: string,
  deckline_id: string,
  page_name?: string | null,
  kpi_id?: string | null,
  kpi_name?: string | null,
  kpi_formula?: string | null,
  serial_no?: string | null,
  is_code_or_description?: CodeOrDescription | null,
  is_format_bold?: boolean | null,
  is_format_italics?: boolean | null,
  is_format_underline?: boolean | null,
  format_text_color?: string | null,
  format_cell_color?: string | null,
  format_cell_default?: CellFormat | null,
  blankline_type?: BlanklineType | null,
  is_format_borderline?: boolean | null,
  footnotes?: Array< number | null > | null,
  subtotal_formula?: string | null,
  subtotal_parent?: string | null,
  is_calculated_kpi?: CalculatedKPIValues | null,
  deckline_drivers?: KPIDriversInput | null,
  is_exception?: boolean | null,
  page_section?: string | null,
  column_template?: string | null,
  adjcalcflag?: boolean | null,
  exceptioncalculatedkpiflag?: boolean | null,
  bordertopflag?: boolean | null,
  borderrightflag?: boolean | null,
  borderbottomflag?: boolean | null,
  borderleftflag?: boolean | null,
  borderweightflag?: BorderWeight | null,
  textunderlineflag?: boolean | null,
  denominator_kpi_id_for_pct?: string | null,
  denominator_kpi_id_drivers?: KPIDriversInput | null,
  denominator_is_calculated_kpi?: CalculatedKPIValues | null,
  denominator_kpi_formula?: string | null,
  root_kpi_id?: string | null,
  kpi_variant_id?: string | null,
  display_name?: string | null,
  denominator_kpi_variant_id?: string | null,
  kpi_name_indent_level?: number | null,
  fxinclflag?: string | null,
  calcdivisionflag?: string | null,
  bps_override_flag?: string | null,
  comments?: Array< CommentInput | null > | null,
};

export type DecklineDeleteItemsInput = {
  page_id: string,
  deckline_id: string,
};

export type DeckColumnOperationsInput = {
  create?: Array< DeckColumnItemsInput | null > | null,
  update?: Array< DeckColumnItemsInput | null > | null,
  delete?: Array< DeckColumnDeleteItemsInput | null > | null,
};

export type DeckColumnItemsInput = {
  page_id: string,
  deckcolumn_id: string,
  column_template?: string | null,
  page_section?: string | null,
  column_no?: number | null,
  column_title?: string | null,
  column_name?: string | null,
  no_of_columns?: number | null,
  column_description?: string | null,
  scenario_display_name?: string | null,
  scenario_period?: string | null,
  block_id?: number | null,
  footnotes?: Array< number | null > | null,
  comparison_scenario?: string | null,
  comparison_scenario_period?: string | null,
  fx_scenario?: string | null,
  fx_scenario_period?: string | null,
  denominator_scenario?: string | null,
  denominator_scenario_period?: string | null,
  block_header?: string | null,
  non_material_flag?: string | null,
  denominator_kpi_exception_flag?: string | null,
  column_mapping_group?: string | null,
  report_header?: string | null,
  time_grain?: string | null,
  deck_cycle?: string | null,
};

export type DeckColumnDeleteItemsInput = {
  page_id: string,
  deckcolumn_id: string,
};

export type FootnoteOperationsInput = {
  create?: Array< FootnoteItemsInput | null > | null,
  update?: Array< FootnoteItemsInput | null > | null,
  delete?: Array< FootnoteDeleteItemsInput | null > | null,
};

export type FootnoteItemsInput = {
  footnote_id: string,
  page_id: string,
  footnote_no?: string | null,
  footnote_description?: string | null,
};

export type FootnoteDeleteItemsInput = {
  footnote_id: string,
  page_id: string,
};

export type KPIOperationsInput = {
  create?: Array< KPIItemsInput | null > | null,
  update?: Array< KPIItemsInput | null > | null,
  delete?: Array< KPIDeleteItemsInput | null > | null,
};

export type KPIItemsInput = {
  kpi_id: string,
  is_calculated_kpi?: CalculatedKPIValues | null,
  kpi_formula?: string | null,
  kpi_map?: KPIDriversInput | null,
};

export type KPIDeleteItemsInput = {
  kpi_id: string,
};

export type PageOperationsInput = {
  create?: Array< PageItemsInput | null > | null,
  update?: Array< PageItemsInput | null > | null,
  delete?: Array< PageDeleteItemsInput | null > | null,
};

export type PageItemsInput = {
  page_id: string,
  page_name?: string | null,
  page_grain?: string | null,
  page_no?: number | null,
  page_drivers?: KPIDriversInput | null,
  previous_page_id?: string | null,
  next_page_id?: string | null,
  page_type?: string | null,
  denominator_label?: DenominatorLabelValues | null,
};

export type PageDeleteItemsInput = {
  page_id: string,
};

export type ScenarioManagementOperationsInput = {
  create?: Array< ScenarioManagementItemsInput | null > | null,
  update?: Array< ScenarioManagementItemsInput | null > | null,
  delete?: Array< ScenarioManagementDeleteItemsInput | null > | null,
};

export type ScenarioManagementItemsInput = {
  scenario_id: string,
  deck_cycle?: string | null,
  month?: string | null,
  page_name?: string | null,
  sno?: string | null,
  page_no?: string | null,
  is_external_page?: boolean | null,
  page_grain?: string | null,
  schedule_type: ScheduleType,
  is_supplemental?: boolean | null,
  is_blankpage?: boolean | null,
  toc_sno?: string | null,
  toc_page_no?: string | null,
};

export type ScenarioManagementDeleteItemsInput = {
  scenario_id: string,
  schedule_type: ScheduleType,
};

export type AuditHistoryOperationsInput = {
  create?: Array< AuditHistoryItemsInput | null > | null,
};

export type AuditHistoryItemsInput = {
  page_id: string,
  change_type?: string | null,
  before?: string | null,
  after?: string | null,
  user?: string | null,
  dateTime?: string | null,
  row?: string | null,
  page_name?: string | null,
};

export type PublishDeckInput = {
  deck_id: string,
  publish_id: string,
  publish_timestamp?: string | null,
  schedule_type: ScheduleType,
  month?: string | null,
  deck_cycle: string,
  publish_iteration_type?: PublishIterationType | null,
};

export enum PublishIterationType {
  DEFAULT = "DEFAULT",
  AWS_REFRESH = "AWS_REFRESH",
}


export type UpdateDeckInput = {
  deck_id: string,
  publish_status?: PublishStatus | null,
  last_updated_date?: string | null,
  has_active_system_run?: boolean | null,
  deck_cycle?: string | null,
};

export type LockEvent = {
  __typename: "LockEvent",
  deck_id: string,
  page_name?: string | null,
  locked_by?: string | null,
  locked_at?: string | null,
  lock_expiry?: string | null,
  lock_scope: LockScope,
};

export enum LockScope {
  DECK = "DECK",
  PAGE = "PAGE",
}


export type CreateRootKPIInput = {
  root_kpi_id: string,
  root_kpi_name: string,
  kpi_type: KPIType,
};

export enum KPIType {
  BASE = "BASE",
  CALCULATED = "CALCULATED",
  EXTERNAL = "EXTERNAL",
}


export type RootKPI = {
  __typename: "RootKPI",
  pk: string,
  sk: string,
  root_kpi_id: string,
  root_kpi_name: string,
  kpi_type: KPIType,
  variants?:  Array<KPIVariant | null > | null,
  created_date?: string | null,
  created_by?: string | null,
  last_updated_date?: string | null,
  last_updated_by?: string | null,
};

export type KPIVariant = {
  __typename: "KPIVariant",
  pk: string,
  sk: string,
  kpi_variant_id: string,
  variant_name: string,
  variant_overrides?: KPIDrivers | null,
  kpi_type: KPIType,
  root_kpi_id: string,
  created_date?: string | null,
  last_updated_date?: string | null,
  created_by?: string | null,
  last_updated_by?: string | null,
};

export type UpdateRootKPIInput = {
  root_kpi_id: string,
  root_kpi_name: string,
};

export type CreateKPIVariantInput = {
  root_kpi_id: string,
  kpi_variant_id: string,
  variant_name?: string | null,
  variant_overrides: KPIDriversInput,
  kpi_type: KPIType,
};

export type UpdateKPIVariantInput = {
  root_kpi_id: string,
  kpi_variant_id: string,
  variant_name?: string | null,
  variant_overrides?: KPIDriversInput | null,
};

export type UpdateKPIVariantResponse = {
  __typename: "UpdateKPIVariantResponse",
  pk: string,
  sk: string,
  kpi_variant_id: string,
  variant_name: string,
  variant_overrides?: KPIDrivers | null,
  kpi_type: KPIType,
  root_kpi_id: string,
  created_date?: string | null,
  last_updated_date?: string | null,
  created_by?: string | null,
  last_updated_by?: string | null,
  affected_page_ids?: Array< string | null > | null,
  updated_decklines?:  Array<Deckline | null > | null,
};

export type DeleteKPIVariantInput = {
  root_kpi_id: string,
  kpi_variant_id: string,
};

export type DeleteKPIVariantResponse = {
  __typename: "DeleteKPIVariantResponse",
  kpi_variant_id: string,
  root_kpi_id: string,
  root_kpi_auto_deleted: boolean,
  affected_page_ids?: Array< string | null > | null,
  deleted_decklines?:  Array<Deckline | null > | null,
  reordered_decklines?:  Array<Deckline | null > | null,
};

export type AuditHistoryPaginatedResponse = {
  __typename: "AuditHistoryPaginatedResponse",
  items?:  Array<AuditHistory | null > | null,
  nextToken?: string | null,
};

export type AuditHistory = {
  __typename: "AuditHistory",
  pk: string,
  sk: string,
  change_type?: string | null,
  before?: string | null,
  after?: string | null,
  user?: string | null,
  dateTime?: string | null,
  row?: string | null,
  page_name?: string | null,
};

export type DeckColumnPaginatedResponse = {
  __typename: "DeckColumnPaginatedResponse",
  items?:  Array<DeckColumn | null > | null,
  nextToken?: string | null,
};

export type KPIPaginatedResponse = {
  __typename: "KPIPaginatedResponse",
  items?:  Array<KPI | null > | null,
  nextToken?: string | null,
};

export type RootKPIPaginatedResponse = {
  __typename: "RootKPIPaginatedResponse",
  items?:  Array<RootKPI | null > | null,
  nextToken?: string | null,
};

export type KPIUsageSummary = {
  __typename: "KPIUsageSummary",
  root_kpi_id: string,
  root_kpi_name: string,
  total_deckline_count: number,
  total_page_count: number,
  total_core_page_count: number,
  total_deck_count: number,
  deck_usage:  Array<DeckUsageDetail | null >,
};

export type DeckUsageDetail = {
  __typename: "DeckUsageDetail",
  deck_id: string,
  deck_name: string,
  page_usage:  Array<CorePageUsageDetail | null >,
};

export type CorePageUsageDetail = {
  __typename: "CorePageUsageDetail",
  core_page_name: string,
  pages:  Array<PageUsageDetail | null >,
};

export type PageUsageDetail = {
  __typename: "PageUsageDetail",
  page_id: string,
  page_name: string,
  deckline_count: number,
  kpi_variant_ids: Array< string | null >,
};

export type KPIHierarchyAuditEntityInput = {
  entity_type: KPIHierarchyAuditEntityType,
  entity_id: string,
};

export enum KPIHierarchyAuditEntityType {
  ROOT_KPI = "ROOT_KPI",
  KPI_VARIANT = "KPI_VARIANT",
}


export type CreateDeckMutationVariables = {
  userAlias: string,
  request: CreateDeckInput,
};

export type CreateDeckMutation = {
  createDeck?:  {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
  } | null,
};

export type CreateTOCEntryMutationVariables = {
  userAlias: string,
  request: CreateTOCEntryInput,
};

export type CreateTOCEntryMutation = {
  createTOCEntry?:  {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null,
};

export type CreateScenarioManagementEntryMutationVariables = {
  userAlias: string,
  request: CreateScenarioManagementEntryInput,
};

export type CreateScenarioManagementEntryMutation = {
  createScenarioManagementEntry?:  {
    __typename: "ScenarioManagementEntry",
    pk: string,
    sk: string,
    scenario_id: string,
    deck_cycle?: string | null,
    month?: string | null,
    page_name?: string | null,
    page_no?: string | null,
    sno?: string | null,
    is_external_page?: boolean | null,
    page_grain?: string | null,
    schedule_type: ScheduleType,
    last_updated_date?: string | null,
    is_supplemental?: boolean | null,
    is_blankpage?: boolean | null,
    toc_sno?: string | null,
    toc_page_no?: string | null,
  } | null,
};

export type CreatePageMutationVariables = {
  userAlias: string,
  request: CreatePageInput,
};

export type CreatePageMutation = {
  createPage?:  {
    __typename: "Page",
    pk: string,
    sk: string,
    pageGSI_pk?: string | null,
    pageGSI_sk?: string | null,
    page_name?: string | null,
    deck_id?: string | null,
    page_grain?: string | null,
    page_no?: number | null,
    page_drivers?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    previous_page_id?: string | null,
    next_page_id?: string | null,
    page_type?: string | null,
    denominator_label?: DenominatorLabelValues | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
  } | null,
};

export type CreateDecklineMutationVariables = {
  userAlias: string,
  request: CreateDecklineInput,
};

export type CreateDecklineMutation = {
  createDeckline?:  {
    __typename: "Deckline",
    pk: string,
    sk: string,
    page_name?: string | null,
    kpi_id?: string | null,
    kpi_name?: string | null,
    kpi_formula?: string | null,
    serial_no?: string | null,
    is_code_or_description?: CodeOrDescription | null,
    is_format_bold?: boolean | null,
    is_format_italics?: boolean | null,
    is_format_underline?: boolean | null,
    format_text_color?: string | null,
    format_cell_color?: string | null,
    format_cell_default?: CellFormat | null,
    blankline_type?: BlanklineType | null,
    is_format_borderline?: boolean | null,
    footnotes?: Array< number | null > | null,
    subtotal_formula?: string | null,
    subtotal_parent?: string | null,
    is_calculated_kpi?: CalculatedKPIValues | null,
    deckline_drivers?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    is_exception?: boolean | null,
    page_section?: string | null,
    column_template?: string | null,
    adjcalcflag?: boolean | null,
    exceptioncalculatedkpiflag?: boolean | null,
    bordertopflag?: boolean | null,
    borderrightflag?: boolean | null,
    borderbottomflag?: boolean | null,
    borderleftflag?: boolean | null,
    borderweightflag?: BorderWeight | null,
    textunderlineflag?: boolean | null,
    denominator_kpi_id_for_pct?: string | null,
    denominator_kpi_id_drivers?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    denominator_is_calculated_kpi?: CalculatedKPIValues | null,
    denominator_kpi_formula?: string | null,
    root_kpi_id?: string | null,
    kpi_variant_id?: string | null,
    display_name?: string | null,
    denominator_kpi_variant_id?: string | null,
    kpi_name_indent_level?: number | null,
    fxinclflag?: string | null,
    calcdivisionflag?: string | null,
    bps_override_flag?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      commentId: string,
      user: string,
      commentDesc: string,
      timestamp: string,
    } | null > | null,
  } | null,
};

export type CreateDeckColumnMutationVariables = {
  userAlias: string,
  request: CreateDeckColumnInput,
};

export type CreateDeckColumnMutation = {
  createDeckColumn?:  {
    __typename: "DeckColumn",
    pk: string,
    sk: string,
    deckColumnGSI_pk?: string | null,
    deckColumnGSI_sk?: string | null,
    deck_id?: string | null,
    column_template?: string | null,
    page_section?: string | null,
    column_no?: number | null,
    column_title?: string | null,
    column_name?: string | null,
    no_of_columns?: number | null,
    column_description?: string | null,
    scenario_display_name?: string | null,
    scenario_period?: string | null,
    block_id?: number | null,
    comparison_scenario?: string | null,
    comparison_scenario_period?: string | null,
    fx_scenario?: string | null,
    fx_scenario_period?: string | null,
    denominator_scenario?: string | null,
    denominator_scenario_period?: string | null,
    block_header?: string | null,
    non_material_flag?: string | null,
    denominator_kpi_exception_flag?: string | null,
    last_updated_date?: string | null,
    column_mapping_group?: string | null,
    report_header?: string | null,
    time_grain?: string | null,
    deck_cycle?: string | null,
  } | null,
};

export type CreateKPIMutationVariables = {
  userAlias: string,
  request: CreateKPIInput,
};

export type CreateKPIMutation = {
  createKPI?:  {
    __typename: "KPI",
    pk: string,
    sk: string,
    is_calculated_kpi?: CalculatedKPIValues | null,
    kpi_formula?: string | null,
    kpi_map?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    last_updated_date?: string | null,
  } | null,
};

export type CreateFootnoteMutationVariables = {
  userAlias: string,
  request: CreateFootnoteInput,
};

export type CreateFootnoteMutation = {
  createFootnote?:  {
    __typename: "Footnote",
    pk: string,
    sk: string,
    footnote_no?: string | null,
    footnote_description?: string | null,
  } | null,
};

export type SaveDeckMutationVariables = {
  userAlias?: string | null,
  request: SaveDeckInput,
};

export type SaveDeckMutation = {
  saveDeck?: boolean | null,
};

export type PublishDeckMutationVariables = {
  userAlias?: string | null,
  request: PublishDeckInput,
};

export type PublishDeckMutation = {
  publishDeck?: boolean | null,
};

export type UpdateDeckMutationVariables = {
  userAlias: string,
  request: UpdateDeckInput,
};

export type UpdateDeckMutation = {
  updateDeck?:  {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
  } | null,
};

export type UpdateSystemRunStatusMutationVariables = {
  userAlias: string,
  has_active_system_run: boolean,
};

export type UpdateSystemRunStatusMutation = {
  updateSystemRunStatus?: boolean | null,
};

export type LockDeckMutationVariables = {
  deck_id: string,
  userAlias?: string | null,
};

export type LockDeckMutation = {
  lockDeck?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type ReleaseDeckLockMutationVariables = {
  deck_id: string,
  userAlias?: string | null,
  expected_schedule_name?: string | null,
};

export type ReleaseDeckLockMutation = {
  releaseDeckLock?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type LockPageMutationVariables = {
  deck_id: string,
  page_name: string,
  userAlias?: string | null,
};

export type LockPageMutation = {
  lockPage?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type ReleasePageLockMutationVariables = {
  deck_id: string,
  page_name: string,
  userAlias?: string | null,
  expected_schedule_name?: string | null,
};

export type ReleasePageLockMutation = {
  releasePageLock?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type CreateRootKPIMutationVariables = {
  userAlias?: string | null,
  request: CreateRootKPIInput,
};

export type CreateRootKPIMutation = {
  createRootKPI?:  {
    __typename: "RootKPI",
    pk: string,
    sk: string,
    root_kpi_id: string,
    root_kpi_name: string,
    kpi_type: KPIType,
    variants?:  Array< {
      __typename: "KPIVariant",
      pk: string,
      sk: string,
      kpi_variant_id: string,
      variant_name: string,
      variant_overrides?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      kpi_type: KPIType,
      root_kpi_id: string,
      created_date?: string | null,
      last_updated_date?: string | null,
      created_by?: string | null,
      last_updated_by?: string | null,
    } | null > | null,
    created_date?: string | null,
    created_by?: string | null,
    last_updated_date?: string | null,
    last_updated_by?: string | null,
  } | null,
};

export type UpdateRootKPIMutationVariables = {
  userAlias?: string | null,
  request: UpdateRootKPIInput,
};

export type UpdateRootKPIMutation = {
  updateRootKPI?:  {
    __typename: "RootKPI",
    pk: string,
    sk: string,
    root_kpi_id: string,
    root_kpi_name: string,
    kpi_type: KPIType,
    variants?:  Array< {
      __typename: "KPIVariant",
      pk: string,
      sk: string,
      kpi_variant_id: string,
      variant_name: string,
      variant_overrides?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      kpi_type: KPIType,
      root_kpi_id: string,
      created_date?: string | null,
      last_updated_date?: string | null,
      created_by?: string | null,
      last_updated_by?: string | null,
    } | null > | null,
    created_date?: string | null,
    created_by?: string | null,
    last_updated_date?: string | null,
    last_updated_by?: string | null,
  } | null,
};

export type DeleteRootKPIMutationVariables = {
  userAlias?: string | null,
  root_kpi_id: string,
};

export type DeleteRootKPIMutation = {
  deleteRootKPI?: boolean | null,
};

export type CreateKPIVariantMutationVariables = {
  userAlias?: string | null,
  request: CreateKPIVariantInput,
};

export type CreateKPIVariantMutation = {
  createKPIVariant?:  {
    __typename: "KPIVariant",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
  } | null,
};

export type UpdateKPIVariantMutationVariables = {
  userAlias?: string | null,
  request: UpdateKPIVariantInput,
};

export type UpdateKPIVariantMutation = {
  updateKPIVariant?:  {
    __typename: "UpdateKPIVariantResponse",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    affected_page_ids?: Array< string | null > | null,
    updated_decklines?:  Array< {
      __typename: "Deckline",
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      deckline_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type DeleteKPIVariantMutationVariables = {
  userAlias?: string | null,
  request: DeleteKPIVariantInput,
};

export type DeleteKPIVariantMutation = {
  deleteKPIVariant?:  {
    __typename: "DeleteKPIVariantResponse",
    kpi_variant_id: string,
    root_kpi_id: string,
    root_kpi_auto_deleted: boolean,
    affected_page_ids?: Array< string | null > | null,
    deleted_decklines?:  Array< {
      __typename: "Deckline",
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      deckline_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
    reordered_decklines?:  Array< {
      __typename: "Deckline",
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      deckline_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type GetDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetDeckQuery = {
  getDeck?:  {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
  } | null,
};

export type GetLockedPagesForDeckQueryVariables = {
  deck_id: string,
  userAlias?: string | null,
};

export type GetLockedPagesForDeckQuery = {
  getLockedPagesForDeck?:  Array< {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null > | null,
};

export type GetAllDecksQueryVariables = {
  userAlias?: string | null,
};

export type GetAllDecksQuery = {
  getAllDecks?:  Array< {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
  } | null > | null,
};

export type GetTOCEntryQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  toc_id: string,
};

export type GetTOCEntryQuery = {
  getTOCEntry?:  Array< {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null > | null,
};

export type GetAllTOCEntriesForaDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetAllTOCEntriesForaDeckQuery = {
  getAllTOCEntriesForaDeck?:  Array< {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null > | null,
};

export type GetTOCEntriesForaDeckByPageStatusQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  is_active: boolean,
};

export type GetTOCEntriesForaDeckByPageStatusQuery = {
  getTOCEntriesForaDeckByPageStatus?:  Array< {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null > | null,
};

export type GetActiveTOCEntriesByScheduleTypeQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  is_active: boolean,
  schedule_type: ScheduleType,
};

export type GetActiveTOCEntriesByScheduleTypeQuery = {
  getActiveTOCEntriesByScheduleType?:  Array< {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null > | null,
};

export type GetAllScenarioManagementEntriesForaDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetAllScenarioManagementEntriesForaDeckQuery = {
  getAllScenarioManagementEntriesForaDeck?:  Array< {
    __typename: "ScenarioManagementEntry",
    pk: string,
    sk: string,
    scenario_id: string,
    deck_cycle?: string | null,
    month?: string | null,
    page_name?: string | null,
    page_no?: string | null,
    sno?: string | null,
    is_external_page?: boolean | null,
    page_grain?: string | null,
    schedule_type: ScheduleType,
    last_updated_date?: string | null,
    is_supplemental?: boolean | null,
    is_blankpage?: boolean | null,
    toc_sno?: string | null,
    toc_page_no?: string | null,
  } | null > | null,
};

export type GetScenarioManagementEntriesByScheduleTypeQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  schedule_type: ScheduleType,
};

export type GetScenarioManagementEntriesByScheduleTypeQuery = {
  getScenarioManagementEntriesByScheduleType?:  Array< {
    __typename: "ScenarioManagementEntry",
    pk: string,
    sk: string,
    scenario_id: string,
    deck_cycle?: string | null,
    month?: string | null,
    page_name?: string | null,
    page_no?: string | null,
    sno?: string | null,
    is_external_page?: boolean | null,
    page_grain?: string | null,
    schedule_type: ScheduleType,
    last_updated_date?: string | null,
    is_supplemental?: boolean | null,
    is_blankpage?: boolean | null,
    toc_sno?: string | null,
    toc_page_no?: string | null,
  } | null > | null,
};

export type GetPageQueryVariables = {
  userAlias?: string | null,
  page_id: string,
};

export type GetPageQuery = {
  getPage?:  {
    __typename: "Page",
    pk: string,
    sk: string,
    pageGSI_pk?: string | null,
    pageGSI_sk?: string | null,
    page_name?: string | null,
    deck_id?: string | null,
    page_grain?: string | null,
    page_no?: number | null,
    page_drivers?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    previous_page_id?: string | null,
    next_page_id?: string | null,
    page_type?: string | null,
    denominator_label?: DenominatorLabelValues | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
  } | null,
};

export type GetDecklinesQueryVariables = {
  userAlias?: string | null,
  page_id: string,
};

export type GetDecklinesQuery = {
  getDecklines?:  Array< {
    __typename: "Deckline",
    pk: string,
    sk: string,
    page_name?: string | null,
    kpi_id?: string | null,
    kpi_name?: string | null,
    kpi_formula?: string | null,
    serial_no?: string | null,
    is_code_or_description?: CodeOrDescription | null,
    is_format_bold?: boolean | null,
    is_format_italics?: boolean | null,
    is_format_underline?: boolean | null,
    format_text_color?: string | null,
    format_cell_color?: string | null,
    format_cell_default?: CellFormat | null,
    blankline_type?: BlanklineType | null,
    is_format_borderline?: boolean | null,
    footnotes?: Array< number | null > | null,
    subtotal_formula?: string | null,
    subtotal_parent?: string | null,
    is_calculated_kpi?: CalculatedKPIValues | null,
    deckline_drivers?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    is_exception?: boolean | null,
    page_section?: string | null,
    column_template?: string | null,
    adjcalcflag?: boolean | null,
    exceptioncalculatedkpiflag?: boolean | null,
    bordertopflag?: boolean | null,
    borderrightflag?: boolean | null,
    borderbottomflag?: boolean | null,
    borderleftflag?: boolean | null,
    borderweightflag?: BorderWeight | null,
    textunderlineflag?: boolean | null,
    denominator_kpi_id_for_pct?: string | null,
    denominator_kpi_id_drivers?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    denominator_is_calculated_kpi?: CalculatedKPIValues | null,
    denominator_kpi_formula?: string | null,
    root_kpi_id?: string | null,
    kpi_variant_id?: string | null,
    display_name?: string | null,
    denominator_kpi_variant_id?: string | null,
    kpi_name_indent_level?: number | null,
    fxinclflag?: string | null,
    calcdivisionflag?: string | null,
    bps_override_flag?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      commentId: string,
      user: string,
      commentDesc: string,
      timestamp: string,
    } | null > | null,
  } | null > | null,
};

export type GetDeckColumnsQueryVariables = {
  userAlias?: string | null,
  page_id: string,
};

export type GetDeckColumnsQuery = {
  getDeckColumns?:  Array< {
    __typename: "DeckColumn",
    pk: string,
    sk: string,
    deckColumnGSI_pk?: string | null,
    deckColumnGSI_sk?: string | null,
    deck_id?: string | null,
    column_template?: string | null,
    page_section?: string | null,
    column_no?: number | null,
    column_title?: string | null,
    column_name?: string | null,
    no_of_columns?: number | null,
    column_description?: string | null,
    scenario_display_name?: string | null,
    scenario_period?: string | null,
    block_id?: number | null,
    comparison_scenario?: string | null,
    comparison_scenario_period?: string | null,
    fx_scenario?: string | null,
    fx_scenario_period?: string | null,
    denominator_scenario?: string | null,
    denominator_scenario_period?: string | null,
    block_header?: string | null,
    non_material_flag?: string | null,
    denominator_kpi_exception_flag?: string | null,
    last_updated_date?: string | null,
    column_mapping_group?: string | null,
    report_header?: string | null,
    time_grain?: string | null,
    deck_cycle?: string | null,
  } | null > | null,
};

export type GetKPIQueryVariables = {
  userAlias?: string | null,
  kpi_id: string,
};

export type GetKPIQuery = {
  getKPI?:  {
    __typename: "KPI",
    pk: string,
    sk: string,
    is_calculated_kpi?: CalculatedKPIValues | null,
    kpi_formula?: string | null,
    kpi_map?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    last_updated_date?: string | null,
  } | null,
};

export type GetFootnoteForPageQueryVariables = {
  userAlias?: string | null,
  page_id: string,
  footnote_id?: string | null,
};

export type GetFootnoteForPageQuery = {
  getFootnoteForPage?:  Array< {
    __typename: "Footnote",
    pk: string,
    sk: string,
    footnote_no?: string | null,
    footnote_description?: string | null,
  } | null > | null,
};

export type GetAuditHistoryForPageQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  page_id: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAuditHistoryForPageQuery = {
  getAuditHistoryForPage?:  {
    __typename: "AuditHistoryPaginatedResponse",
    items?:  Array< {
      __typename: "AuditHistory",
      pk: string,
      sk: string,
      change_type?: string | null,
      before?: string | null,
      after?: string | null,
      user?: string | null,
      dateTime?: string | null,
      row?: string | null,
      page_name?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAuditHistoryForDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetAuditHistoryForDeckQuery = {
  getAuditHistoryForDeck?:  Array< {
    __typename: "AuditHistory",
    pk: string,
    sk: string,
    change_type?: string | null,
    before?: string | null,
    after?: string | null,
    user?: string | null,
    dateTime?: string | null,
    row?: string | null,
    page_name?: string | null,
  } | null > | null,
};

export type GetDeckColumnForDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  publish_timestamp?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetDeckColumnForDeckQuery = {
  getDeckColumnForDeck?:  {
    __typename: "DeckColumnPaginatedResponse",
    items?:  Array< {
      __typename: "DeckColumn",
      pk: string,
      sk: string,
      deckColumnGSI_pk?: string | null,
      deckColumnGSI_sk?: string | null,
      deck_id?: string | null,
      column_template?: string | null,
      page_section?: string | null,
      column_no?: number | null,
      column_title?: string | null,
      column_name?: string | null,
      no_of_columns?: number | null,
      column_description?: string | null,
      scenario_display_name?: string | null,
      scenario_period?: string | null,
      block_id?: number | null,
      comparison_scenario?: string | null,
      comparison_scenario_period?: string | null,
      fx_scenario?: string | null,
      fx_scenario_period?: string | null,
      denominator_scenario?: string | null,
      denominator_scenario_period?: string | null,
      block_header?: string | null,
      non_material_flag?: string | null,
      denominator_kpi_exception_flag?: string | null,
      last_updated_date?: string | null,
      column_mapping_group?: string | null,
      report_header?: string | null,
      time_grain?: string | null,
      deck_cycle?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAllKPIsQueryVariables = {
  userAlias?: string | null,
  deck_id?: string | null,
  publish_timestamp?: string | null,
  kpi_type?: KPIType | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllKPIsQuery = {
  getAllKPIs?:  {
    __typename: "KPIPaginatedResponse",
    items?:  Array< {
      __typename: "KPI",
      pk: string,
      sk: string,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_formula?: string | null,
      kpi_map?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      last_updated_date?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetKPIUpdatesForDeckQueryVariables = {
  userAlias: string,
  deck_id: string,
  publish_timestamp: string,
  kpi_type?: KPIType | null,
  nextToken?: string | null,
};

export type GetKPIUpdatesForDeckQuery = {
  getKPIUpdatesForDeck?:  {
    __typename: "KPIPaginatedResponse",
    items?:  Array< {
      __typename: "KPI",
      pk: string,
      sk: string,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_formula?: string | null,
      kpi_map?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      last_updated_date?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetPagesByPageNameQueryVariables = {
  userAlias?: string | null,
  page_name: string,
  page_grain?: string | null,
  deck_id?: string | null,
};

export type GetPagesByPageNameQuery = {
  getPagesByPageName?:  Array< {
    __typename: "Page",
    pk: string,
    sk: string,
    pageGSI_pk?: string | null,
    pageGSI_sk?: string | null,
    page_name?: string | null,
    deck_id?: string | null,
    page_grain?: string | null,
    page_no?: number | null,
    page_drivers?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    previous_page_id?: string | null,
    next_page_id?: string | null,
    page_type?: string | null,
    denominator_label?: DenominatorLabelValues | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
  } | null > | null,
};

export type GetRootKPIsQueryVariables = {
  userAlias?: string | null,
  root_kpi_id?: string | null,
  nextToken?: string | null,
};

export type GetRootKPIsQuery = {
  getRootKPIs?:  {
    __typename: "RootKPIPaginatedResponse",
    items?:  Array< {
      __typename: "RootKPI",
      pk: string,
      sk: string,
      root_kpi_id: string,
      root_kpi_name: string,
      kpi_type: KPIType,
      variants?:  Array< {
        __typename: "KPIVariant",
        pk: string,
        sk: string,
        kpi_variant_id: string,
        variant_name: string,
        variant_overrides?:  {
          __typename: "KPIDrivers",
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
        } | null,
        kpi_type: KPIType,
        root_kpi_id: string,
        created_date?: string | null,
        last_updated_date?: string | null,
        created_by?: string | null,
        last_updated_by?: string | null,
      } | null > | null,
      created_date?: string | null,
      created_by?: string | null,
      last_updated_date?: string | null,
      last_updated_by?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetVariantsForRootKPIQueryVariables = {
  userAlias?: string | null,
  root_kpi_id: string,
};

export type GetVariantsForRootKPIQuery = {
  getVariantsForRootKPI?:  Array< {
    __typename: "KPIVariant",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
  } | null > | null,
};

export type GetKPIVariantQueryVariables = {
  userAlias?: string | null,
  root_kpi_id: string,
  kpi_variant_id: string,
};

export type GetKPIVariantQuery = {
  getKPIVariant?:  {
    __typename: "KPIVariant",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
  } | null,
};

export type GetRootKPIUsageSummaryQueryVariables = {
  userAlias?: string | null,
  root_kpi_id: string,
};

export type GetRootKPIUsageSummaryQuery = {
  getRootKPIUsageSummary?:  {
    __typename: "KPIUsageSummary",
    root_kpi_id: string,
    root_kpi_name: string,
    total_deckline_count: number,
    total_page_count: number,
    total_core_page_count: number,
    total_deck_count: number,
    deck_usage:  Array< {
      __typename: "DeckUsageDetail",
      deck_id: string,
      deck_name: string,
      page_usage:  Array< {
        __typename: "CorePageUsageDetail",
        core_page_name: string,
        pages:  Array< {
          __typename: "PageUsageDetail",
          page_id: string,
          page_name: string,
          deckline_count: number,
          kpi_variant_ids: Array< string | null >,
        } | null >,
      } | null >,
    } | null >,
  } | null,
};

export type GetVariantUsageSummaryQueryVariables = {
  userAlias?: string | null,
  kpi_variant_id: string,
};

export type GetVariantUsageSummaryQuery = {
  getVariantUsageSummary?:  {
    __typename: "KPIUsageSummary",
    root_kpi_id: string,
    root_kpi_name: string,
    total_deckline_count: number,
    total_page_count: number,
    total_core_page_count: number,
    total_deck_count: number,
    deck_usage:  Array< {
      __typename: "DeckUsageDetail",
      deck_id: string,
      deck_name: string,
      page_usage:  Array< {
        __typename: "CorePageUsageDetail",
        core_page_name: string,
        pages:  Array< {
          __typename: "PageUsageDetail",
          page_id: string,
          page_name: string,
          deckline_count: number,
          kpi_variant_ids: Array< string | null >,
        } | null >,
      } | null >,
    } | null >,
  } | null,
};

export type GetKPIHierarchyAuditHistoryQueryVariables = {
  userAlias?: string | null,
  entities?: Array< KPIHierarchyAuditEntityInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetKPIHierarchyAuditHistoryQuery = {
  getKPIHierarchyAuditHistory?:  {
    __typename: "AuditHistoryPaginatedResponse",
    items?:  Array< {
      __typename: "AuditHistory",
      pk: string,
      sk: string,
      change_type?: string | null,
      before?: string | null,
      after?: string | null,
      user?: string | null,
      dateTime?: string | null,
      row?: string | null,
      page_name?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type OnLockDeckSubscriptionVariables = {
};

export type OnLockDeckSubscription = {
  onLockDeck?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type OnReleaseDeckLockSubscriptionVariables = {
};

export type OnReleaseDeckLockSubscription = {
  onReleaseDeckLock?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type OnLockPageSubscriptionVariables = {
};

export type OnLockPageSubscription = {
  onLockPage?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type OnReleasePageLockSubscriptionVariables = {
};

export type OnReleasePageLockSubscription = {
  onReleasePageLock?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type OnUpdateDeckSubscriptionVariables = {
  publish_status?: PublishStatus | null,
};

export type OnUpdateDeckSubscription = {
  onUpdateDeck?:  {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
  } | null,
};

export type OnUpdateKPIVariantSubscriptionVariables = {
  page_ids?: Array< string | null > | null,
};

export type OnUpdateKPIVariantSubscription = {
  onUpdateKPIVariant?:  {
    __typename: "UpdateKPIVariantResponse",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides?:  {
      __typename: "KPIDrivers",
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
    } | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    affected_page_ids?: Array< string | null > | null,
    updated_decklines?:  Array< {
      __typename: "Deckline",
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      deckline_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type OnDeleteKPIVariantSubscriptionVariables = {
  page_ids?: Array< string | null > | null,
};

export type OnDeleteKPIVariantSubscription = {
  onDeleteKPIVariant?:  {
    __typename: "DeleteKPIVariantResponse",
    kpi_variant_id: string,
    root_kpi_id: string,
    root_kpi_auto_deleted: boolean,
    affected_page_ids?: Array< string | null > | null,
    deleted_decklines?:  Array< {
      __typename: "Deckline",
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      deckline_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
    reordered_decklines?:  Array< {
      __typename: "Deckline",
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      deckline_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type OnUpdateRootKPISubscriptionVariables = {
};

export type OnUpdateRootKPISubscription = {
  onUpdateRootKPI?:  {
    __typename: "RootKPI",
    pk: string,
    sk: string,
    root_kpi_id: string,
    root_kpi_name: string,
    kpi_type: KPIType,
    variants?:  Array< {
      __typename: "KPIVariant",
      pk: string,
      sk: string,
      kpi_variant_id: string,
      variant_name: string,
      variant_overrides?:  {
        __typename: "KPIDrivers",
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
      } | null,
      kpi_type: KPIType,
      root_kpi_id: string,
      created_date?: string | null,
      last_updated_date?: string | null,
      created_by?: string | null,
      last_updated_by?: string | null,
    } | null > | null,
    created_date?: string | null,
    created_by?: string | null,
    last_updated_date?: string | null,
    last_updated_by?: string | null,
  } | null,
};
